import type { PositionModel } from "../../../model/PositionModel";

export type PositionRateGroup = "daily" | "hourly";

function getPositionRateGroup(position: PositionModel): PositionRateGroup {
  if (position.payConfigUnits.includes("hour")) {
    return "hourly";
  }

  if (position.payConfigUnits.some((unit) => unit === "day" || unit === "half-day")) {
    return "daily";
  }

  return position.payrateType === "hourly" ? "hourly" : "daily";
}

export function groupPositionsByRateType(positions: PositionModel[]) {
  const groupedPositions: { group: PositionRateGroup; positions: PositionModel[] }[] = [
    {
      group: "daily",
      positions: positions.filter((position) => getPositionRateGroup(position) === "daily"),
    },
    {
      group: "hourly",
      positions: positions.filter((position) => getPositionRateGroup(position) === "hourly"),
    },
  ];

  return groupedPositions.filter(({ positions }) => positions.length > 0);
}

export function filterPositionsByName(positions: PositionModel[], searchTerm: string) {
  const normalizedSearchTerm = searchTerm.trim().toLowerCase();

  if (!normalizedSearchTerm) return positions;

  return positions.filter((position) =>
    position.displayName.toLowerCase().includes(normalizedSearchTerm),
  );
}
